import { createContext, useContext, useEffect, useMemo, useCallback, useState } from 'react';

const ParticipantEPRContext = createContext({ eprData: null, loading: true, reload: () => {} });
export const useParticipantEPR = () => useContext(ParticipantEPRContext);

export default function ParticipantEPRProvider({ patientId, liveId, children }) {
  const [eprData, setEprData] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_BASE = process.env.REACT_APP_API_URL;
  const endpoint = liveId
    ? `${API_BASE}/api/full-patient-scenario/${liveId}`
    : patientId
      ? `${API_BASE}/api/full-patient/${patientId}`
      : null;

  const loadEPR = useCallback(async () => {
    if (!endpoint) return;
    setLoading(true); // keep old data; UI won’t hang
    try {
      const url = `${endpoint}?t=${Date.now()}`; // cache-buster
      const res = await fetch(url, { headers: { 'Cache-Control': 'no-cache' } });
      const data = await res.json();
      setEprData(data);
      
    } catch (e) {
      console.error('[EPR] load failed', e);
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  // initial load and when endpoint changes
  useEffect(() => { loadEPR(); }, [loadEPR]);

  const reload = useCallback(() => {
    loadEPR();
  }, [loadEPR, endpoint]);

  const value = useMemo(() => ({ eprData, loading, reload }), [eprData, loading, reload]);

  return (
    <ParticipantEPRContext.Provider value={value}>
      {children}
    </ParticipantEPRContext.Provider>
  );
}